import React from 'react'
import { defaultProps } from './index'
import ImageToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ImageToolbarSection'

export const GallerySlideSettings = (settingsProps) => {
  return (
    <>
      {!settingsProps.floating && (
        <>
          <ImageToolbarSection defaultProps={defaultProps} />
        </>
      )}
    </>
  )
}

export const GallerySlideFloatingSettings = () =>
  React.createElement(GallerySlideSettings, { floating: true })
